import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { useAuth } from '@/features/auth';

import { Footer } from '../components/footer';
import { Navbar } from './components/navbar';

/**
 * This element renders as react router's Root element.
 * Please follow the below link for more details
 * https://reactrouter.com/en/main/start/tutorial#nested-routes
 *
 */
export const ProtectedLayout: React.FC = () => {
  const { isLoggedIn, user } = useAuth();
  const { setTheme }: any = useTheme();

  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }

  // set theme of the layout based on signed in method of user
  useEffect(() => {
    setTheme(user?.signedInMethod);
  }, []);

  return (
    <div className="flex flex-col justify-between h-screen">
      {/* custom user message: you can add the message from admin panel */}
      {user?.message ? (
        <div className="fixed left-0 right-0 top-0 z-50 py-1 text-sm font-normal text-center text-white bg-red-500">
          {user.message}
        </div>
      ) : null}

      <Navbar />

      <main className="container relative px-4 mx-auto mb-10 2xl:px-52 md:mb-auto">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};
